import { Program, Provider } from "@coral-xyz/anchor";
import { DirectedStakeToken } from "./idlTypes.js";
import { idl as dstIdl } from "./idl.js";

export const makeDSTProgram = (
  provider?: Provider,
): Program<DirectedStakeToken> => {
  return new Program<DirectedStakeToken>(
    dstIdl as unknown as DirectedStakeToken,
    provider,
  );
};
